import { render, staticRenderFns } from "./MKasaWidget.vue?vue&type=template&id=0c4e33d4"
import script from "./MKasaWidget.vue?vue&type=script&lang=js"
export * from "./MKasaWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports